import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  async showNotification(event) {
    try {
      const response = await event.detail.fetchResponse.response.json()
      if (response.success) {
        this.displayFlash(response.message, "success")
      } else {
        this.displayFlash(response.message, "error")
      }
    } catch (error) {
      this.displayFlash("Setting updated successfully.", "success")
    }
  }

  async showError(event) {
    try {
      const response = await event.detail.fetchResponse.response.json()
      this.displayFlash(response.message || "Failed to update setting.", "error")
    } catch (error) {
      this.displayFlash("Failed to update setting.", "error")
    }
  }

  displayFlash(message, type) {
    const flashId = `flash-${Date.now()}`
    
    const flashHTML = `
      <div id="${flashId}" class="fixed top-5 right-5 z-50">
        <div class="bg-${type === 'success' ? 'green' : 'red'}-100 border-l-4 border-${type === 'success' ? 'green' : 'red'}-500 text-${type === 'success' ? 'green' : 'red'}-700 p-4 shadow-md rounded-md" role="alert">
          <div class="flex">
            <div class="py-1">
              ${type === 'success' ? 
                `<svg class="h-6 w-6 text-green-500 mr-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                </svg>` :
                `<svg class="h-6 w-6 text-red-500 mr-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>`
              }
            </div>
            <div>
              <p class="font-bold">${type === "success" ? "Success" : "Error"}</p>
              <p class="text-sm">${message}</p>
            </div>
          </div>
        </div>
      </div>
    `
    
    document.body.insertAdjacentHTML('beforeend', flashHTML)
    
    setTimeout(() => {
      const element = document.getElementById(flashId)
      if (element) {
        element.remove()
      }
    }, 3000)
  }
}